import React, { Suspense } from 'react';
import { useLocation } from 'react-router-dom';

class PageErrorBoundary extends React.Component<{ children: React.ReactNode; resetKey: string }, { failed: boolean }> {
  state = { failed: false };
  static getDerivedStateFromError() { return { failed: true }; }
  componentDidUpdate(previous: Readonly<{ children: React.ReactNode; resetKey: string }>) {
    if (this.state.failed && previous.resetKey !== this.props.resetKey) this.setState({ failed: false });
  }
  render() {
    if (this.state.failed) return <div role="alert" style={{ padding: 24 }}>
      <p>页面暂时无法加载，请刷新重试，也可以从菜单进入其他功能。</p>
      <button onClick={() => window.location.reload()}>刷新页面</button>
    </div>;
    return this.props.children;
  }
}

/** 加载和异常仅占内容区域，导航始终可用。 */
export default function PageBoundary({ children, quiet = false }: { children: React.ReactNode; quiet?: boolean }) {
  const location = useLocation();
  return <PageErrorBoundary resetKey={location.pathname + location.search}>
    <Suspense fallback={quiet ? null : <div role="status" style={{ padding: 24, color: '#6e6e73' }}>正在打开页面…</div>}>
      {children}
    </Suspense>
  </PageErrorBoundary>;
}
